// extracted by mini-css-extract-plugin
module.exports = {"boxContainer":"SectionBoxComponent_boxContainer__20JmI"};